// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { ContrastPoint } from './contrast-point';


export class ContrastFunction {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):ContrastFunction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

lowerBound(obj?:ContrastPoint):ContrastPoint|null {
  return (obj || new ContrastPoint()).__init(this.bb_pos, this.bb!);
}

upperBound(obj?:ContrastPoint):ContrastPoint|null {
  return (obj || new ContrastPoint()).__init(this.bb_pos + 4, this.bb!);
}

static sizeOf():number {
  return 8;
}

static createContrastFunction(builder:flatbuffers.Builder, lower_bound_from: number, lower_bound_to: number, upper_bound_from: number, upper_bound_to: number):flatbuffers.Offset {
  builder.prep(2, 8);
  builder.prep(2, 4);
  builder.pad(1);
  builder.writeInt8(upper_bound_to);
  builder.writeInt16(upper_bound_from);
  builder.prep(2, 4);
  builder.pad(1);
  builder.writeInt8(lower_bound_to);
  builder.writeInt16(lower_bound_from);
  return builder.offset();
}

}
